/** Formatierungs-Helfer für deutsches Locale. */

const EUR = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});
const EUR_COMPACT = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
  notation: 'compact',
  maximumFractionDigits: 2,
});
const NUM = new Intl.NumberFormat('de-DE');
const NUM_COMPACT = new Intl.NumberFormat('de-DE', { notation: 'compact', maximumFractionDigits: 1 });
const PCT = new Intl.NumberFormat('de-DE', { style: 'percent', maximumFractionDigits: 2 });
const PCT1 = new Intl.NumberFormat('de-DE', { style: 'percent', maximumFractionDigits: 1 });

export function fmtCurrency(v: number): string {
  return EUR.format(v);
}
export function fmtCurrencyCompact(v: number): string {
  // 59.180.906 → "59,18 Mio €" — viel besser für KPI-Kacheln
  return EUR_COMPACT.format(v).replace('Mio. €', 'Mio €').replace('Mrd. €', 'Mrd €').replace('Tsd. €', 'Tsd €');
}
export function fmtNumber(v: number, fractionDigits = 0): string {
  if (fractionDigits === 0) return NUM.format(v);
  return new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(v);
}
export function fmtNumberCompact(v: number): string {
  // 1.986.726 → "1,99 Mio"
  return NUM_COMPACT.format(v).replace('Mio.', 'Mio').replace('Mrd.', 'Mrd').replace('Tsd.', 'Tsd');
}
export function fmtPercent(v: number, fractionDigits = 1): string {
  return fractionDigits === 1 ? PCT1.format(v) : PCT.format(v);
}
export function fmtDate(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}

export const WOCHENTAGE = ['', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
export const WOCHENTAGE_LANG = ['', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
export function fmtWochentag(n: number): string {
  return WOCHENTAGE[n] ?? String(n);
}

export const MONATE = [
  '', 'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez',
];
export const MONATE_LANG = [
  '', 'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
];
